

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { ModuleDetail } from '../models/grade-viewmodels';

@Component({
    computed: {
        ...mapState(['result']),
        ...mapGetters('root', ['label'])
    }
})
export default class ModuleInfo extends Vue {
    public result!: ModuleDetail;
    private labelModule = 'ModuleBooking';

    get events() {
        return this.result.moduleEvents.map(event => event.type).join(', ');
    }
}
